import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { Inventario } from '../../types/inventario';
import { inventarioService } from '../../services';

const columns: ResourceColumn<Inventario>[] = [
  { header: "Data", accessor: "data_contagem" },
  { header: "Criado por", accessor: "operador_username" },
  { header: "Total de Itens", accessor: "itens", render: (item) => (Array.isArray(item.itens) ? item.itens.length : 0) },
  { header: "Observação", accessor: "observacao" },
];

export const InventariosListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ResourceListPage
      title="Inventários"
      description="Gerenciamento de inventários físicos."
      columns={columns}
      service={inventarioService}
      createPath="/admin/estoque/inventarios/novo"
      onEdit={(item) => item.id && navigate(`/admin/estoque/inventarios/${item.id}`)}
    />
  );
};
